module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-4-img-pc@2x_19b16a9eb3222fbfd355c94ee4f1c6ab.png";